import { ThemeSystem } from '../../../views/my-learning/dashboard/themeColor';
import DataTables from './DataTables';

export default DataTables;

interface Sizing {
  label: string;
  value: number;
}
export interface DataTablesProps {
  columns: DataTableColumn[];
  data: any[];
  activeSize?: number;
  sizing?: Sizing[];
  loading?: boolean;
  loadingDelete?: boolean;
  isDelete?: boolean;
  meta?: any;
  isNumbering?: boolean;
  viewText?: string;
  deleteText?: string;
  editText?: string;
  approvedText?: string;
  rejectedText?: string;
  handleAdd?: (cell: any) => void;
  handleView?: (cell: any) => void;
  handleEdit?: (cell: any) => void;
  handleApproved?: (cell: any) => void;
  handleRejected?: (cell: any) => void;
  handleDelete?: (cell: any | undefined) => void;
  handleDownload?: (cell: any) => void;
  handleCustomAction?: (cell: any) => React.ReactNode;
  handleCheckBox?: (index: number) => void;
  emptyMessage?: React.ReactNode | string;
  emptyMessageTitle?: string;
  emptyMessageDescription?: string;
  handleChangeSequence?: (cell: any, type: 'down' | 'up') => void;
  withPagination?: boolean;
  theme?: ThemeSystem;
}

export interface DataTableColumn {
  heading: string;
  props: any;
  id?: string;
  align?: 'left' | 'center' | 'right' | 'justify' | 'char' | undefined;
  width?: number;
  sortable?: boolean;
}

export type SortDirection = 'asc' | 'desc' | null;

export interface SortedConfigurationTable {
  key: string | null;
  direction: SortDirection;
}

export interface DataTableHeadProps {
  columns: DataTableColumn[];
  data: any[];
  sortConfig: SortedConfigurationTable;
  meta?: any;
  isNumbering?: boolean;
  onSort?: (data: any) => void;
  theme?: ThemeSystem;
}

export interface DataTableBodyProps {
  columns: DataTableColumn[];
  data: any[];
  rawData?: any[];
  isNumbering?: boolean;
  noDelete?: boolean;
  meta?: any;
  activePage?: number;
  activePageSize?: number;
  addText?: string;
  viewText?: string;
  deleteText?: string;
  editText?: string;
  approvedText?: string;
  rejectedText?: string;
  downloadText?: string;
  emptyMessage?: React.ReactNode | string;
  emptyMessageTitle?: string;
  emptyMessageDescription?: string;
  handleAdd?: (cell: any) => void;
  handleView?: (cell: any) => void;
  handleEdit?: (cell: any) => void;
  handleDelete?: (cell: any) => void;
  handleApproved?: (cell: any) => void;
  handleRejected?: (cell: any) => void;
  handleChangeSequence?: (cell: any, type: 'down' | 'up') => void;
  handleDownload?: (cell: any) => void;
  handleCustomAction?: (cell: any) => React.ReactNode;
  handleCheckBox?: (index: number) => void;
  theme?: ThemeSystem;
}
